import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center py-4" }
const _hoisted_2 = { class: "col-lg-6 col-7" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}

import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import Connect from "@/views/Widgets/ConnectComponents/Connect.vue";
import Notify from "@/views/Widgets/ConnectComponents/Notify.vue";
import Confirmation from "@/views/Widgets/ConnectComponents/Confirmation.vue";
import NumberSettings from "@/views/Widgets/ConnectComponents/NumberSetting.vue";
import two from "@/views/Widgets/ConnectComponents/2FA.vue";
import Route from "@/views/Widgets/ConnectComponents/Route.vue";
import QM_Managment from "@/views/Widgets/ConnectComponents/QMSetting.vue";
import Appointment from "./appointment.vue";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_base_header = _resolveComponent("base-header")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_header, { class: "pb-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(RouteBreadcrumb)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(NumberSettings, { class: "mt--5" }),
    _createVNode(Connect),
    _createVNode(two),
    _createVNode(Notify),
    _createVNode(Confirmation),
    _createVNode(Route),
    _createVNode(QM_Managment),
    _createVNode(Appointment)
  ]))
}
}

})